import { render } from "./OrderBookTable.vue?vue&type=template&id=3e029132&scoped=true"
import script from "./OrderBookTable.vue?vue&type=script&lang=js"
export * from "./OrderBookTable.vue?vue&type=script&lang=js"

import "./OrderBookTable.vue?vue&type=style&index=0&id=3e029132&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e029132"]])

export default __exports__